import { encryptByPublicKey } from '@/utils/encryptByPublicKey';
import { buildSealPlaintext, getDeviceSignals } from '@/utils/deviceFingerprint';

/**
 * 构建 X-Client-Seal Header 值
 * 解密后明文: v2|fp8|ts6|n2|z3|s5|cp2|lg2|u4|v4|w4
 */
export function buildClientSeal() {
  const signals = getDeviceSignals();
  if (!signals || !signals.fp8) {
    return null;
  }

  const plain = buildSealPlaintext(signals);
  return encryptByPublicKey(plain);
}
